import { SettingsParamType, createSettingsParams } from '@wix/tpa-settings';
import type { ItemImage } from 'root/apiTypes';
import type { ExtractSettingParamValue } from 'root/components/Menus/settingsParams';

export type IDisplaySettingsParams = {
  checkPlaceholderMenu?: SettingsParamType.Object;
  checkPricingMenus?: SettingsParamType.Object;
  imagePlaceholder: SettingsParamType.Object;
  menusSideImage: SettingsParamType.Object;
  showZeroPrice: SettingsParamType.Boolean;
  showZeroPriceToAll: SettingsParamType.Boolean;
  showImagePlaceholder: SettingsParamType.Boolean;
  showPlaceholderToAll: SettingsParamType.Boolean;
  showModifierIcon: SettingsParamType.Boolean;
  showItemExpandedImage: SettingsParamType.Boolean;
  showItemMultiImagesGallery: SettingsParamType.Boolean;
};

export type MenuOrder = { id: string; checked: boolean };

export const DisplaySettingsParams = createSettingsParams<IDisplaySettingsParams>({
  checkPlaceholderMenu: {
    type: SettingsParamType.Object,
    getDefaultValue: () => undefined,
  },
  checkPricingMenus: {
    type: SettingsParamType.Object,
    getDefaultValue: () => undefined,
  },
  imagePlaceholder: {
    type: SettingsParamType.Object,
    getDefaultValue: () => {
      try {
        const { DEFAULT_PLACEHOLDER_IMAGE } = require('root/assets/images/ItemPlaceholderImage');
        return { url: DEFAULT_PLACEHOLDER_IMAGE } as ItemImage;
      } catch {
        return { url: '' } as ItemImage;
      }
    },
  },
  menusSideImage: {
    type: SettingsParamType.Object,
    getDefaultValue: () => {
      try {
        const { DEFAULT_MENUS_SIDE_IMAGE } = require('root/assets/images/MenusSideImage');
        return { url: DEFAULT_MENUS_SIDE_IMAGE } as ItemImage;
      } catch {
        return { url: '' } as ItemImage;
      }
    },
  },
  showZeroPrice: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => false,
  },
  showZeroPriceToAll: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showImagePlaceholder: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => false,
  },
  showPlaceholderToAll: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showModifierIcon: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showItemExpandedImage: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showItemMultiImagesGallery: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
});

export type DisplaySettingsParamsValue = {
  [K in keyof IDisplaySettingsParams]: ExtractSettingParamValue<(typeof DisplaySettingsParams)[K]>;
};
